export function programsSelectors(state) {
  return state.programs;
}